import { get as getUser } from 'js/lib/user';

import localStorageEx from 'bundles/common/utils/localStorageEx';

const STORAGE_KEY_SUFFIX = '.playSoundEffects';
const DEFAULT_PLAY_SOUND_EFFECTS = true;

function getStorageKey(): string {
  return `${getUser().id}${STORAGE_KEY_SUFFIX}`;
}

export function getShouldPlaySoundEffects(): boolean {
  return localStorageEx.getItem<boolean>(getStorageKey(), (value) => value === 'true', DEFAULT_PLAY_SOUND_EFFECTS);
}

export function setShouldPlaySoundEffects(shouldPlay: boolean): void {
  localStorageEx.setItem<boolean>(getStorageKey(), shouldPlay, String);
}
